import {
  ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION,
  ACT_INSTANCES_FETCH_CHARACTERISTICS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_GET_CHARACTERISTIC_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_ADD_CHARACTERISTIC_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_DELETE_CHARACTERISTIC_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS,
  ACT_INSTANCES_SET_SELECTED_CHARACTERISTIC,
} from '../../constants/actions';

const defaultState = {
  characteristics: [],
  singleCharacteristic: undefined,
  didLoadCharacteristics: false,
  isLoadingCharacteristics: false,
  isLoadingSingleCharacteristic: false,
  isAddingCharacteristic: false,
  isDeletingCharacteristic: false,
  isCharacteristicDeleted: false,
  selectedCharacteristic: undefined,
  filters: {
    dynasties: [],
    cities: [],
    tags: [],
    types: [],
  },
};

const componentsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION:
      return {
        ...state,
        characteristics: [],
        isLoadingCharacteristics: true,
        didLoadCharacteristics: false,
      };
    case ACT_INSTANCES_FETCH_CHARACTERISTICS_SUCCESS_ACTION:
      return {
        ...state,
        characteristics: action.payload,
        isLoadingCharacteristics: false,
        didLoadCharacteristics: true,
      };
    case ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION:
      return {
        ...state,
        isAddingCharacteristic: true,
      };
    case ACT_INSTANCES_ADD_CHARACTERISTIC_SUCCESS_ACTION: {
      const newComponentsList = state.components.push(action.payload);
      return {
        ...state,
        isAddingCharacteristic: false,
        characteristics: newComponentsList,
      };
    }
    case ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION:
      return {
        ...state,
        singleCharacteristic: undefined,
        isLoadingCharacteristics: true,
      };
    case ACT_INSTANCES_GET_CHARACTERISTIC_SUCCESS_ACTION:
      return {
        ...state,
        singleCharacteristic: action.payload,
        isLoadingSingleCharacteristic: false,
      };
    case ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION:
      return {
        ...state,
        isDeletingCharacteristic: true,
        isCharacteristicDeleted: false,
      };
    case ACT_INSTANCES_DELETE_CHARACTERISTIC_SUCCESS_ACTION:
      return {
        ...state,
        isDeletingCharacteristic: false,
        isCharacteristicDeleted: true,
      };
    case ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ACT_INSTANCES_SET_SELECTED_CHARACTERISTIC:
      return {
        ...state,
        selectedCharacteristic: action.payload,
      };
    default:
      return state;
  }
};

export default componentsReducer;
